<template>
	<div id="page-content">

		<div id="product-categories">


			<div id="product-filters" class="col-md-3" v-if="!showr">
				<h1>Our Products</h1>
				<ul>
					<li><a href="#" @click.prevent="category('', $event)" class="capitalize category active-category">All</a></li>

					<li v-for="c in filters.category"><a href="#" 
						v-on:click.prevent="category(filterId(c), $event)" 
						class="capitalize category"
					>{{ filterName(c) }}</a></li>
				</ul>
			</div>

			
			<div class="col-md-9" id="products">
			<h1 v-if="showr">Our Products</h1>
				<div id="product-search">
					<div>

						<!-- maxprice -->
						<input @change="maxprice" @keyup="maxprice" type="text" name="maxprice" placeholder="Enter max price" />

						<!-- category -->
						<select v-if="showr" v-on:change="advFilters('category', $event)">
							<option value="">Category</option>
							<option v-for="category in filters.category" :value="filterId(category)">{{ filterName(category) }}</option>
						</select>

						<!-- material -->
						<select v-on:change="advFilters('materials', $event)" name="materials">
							<option value="">Material</option>
							<option value="">All</option>
							<option v-for="material in filters.materials" :value="filterId(material)" class="capitalize">{{ filterName(material) }}</option>
						</select>

						<!-- advanced search -->
						<button @click="advs" class="button-type-j" v-bind:class="{showadvs: showadvs}">Advanced Search</button>

					</div>
				</div>

				<!-- advanced search -->
				<div class="clearboth"></div>
				<transition name="fade">
					<div id="advanced-product-search" v-if="showadvs">
						<div>
							<!-- design -->
							<select v-on:change="advFilters('design', $event)">
								<option value="">Design</option>
								<option v-for="design in filters.design" :value="filterId(design)">{{ filterName(design) }}</option>	
							</select>

							<!-- finish -->
							<select v-on:change="advFilters('finish', $event)">
								<option value="">Finish</option>
								<option v-for="finish in filters.finish" :value="filterId(finish)">{{ filterName(finish) }}</option>
							</select>

							<!-- socket -->
							<select v-on:change="advFilters('socket', $event)">
								<option value="">Socket Type</option>
								<option v-for="sockettype in filters.sockettype" :value="filterId(sockettype)">{{ filterName(sockettype) }}</option>
							</select>

							<!-- place -->
							<select v-on:change="advFilters('forplace', $event)">
								<option value="">Place</option>
								<option v-for="place in filters.place" :value="filterId(place)">{{ filterName(place) }}</option>
							</select>
						</div>
					</div>
				</transition>
				<div class="clearboth"></div>
				
				<!-- products -->
				<router-link :to="'/products/product/' + product.code" class="product col-sm-6 col-md-4" v-for="product in products" :key="product.code" :id="product.code">
					<div>
						<img :src="'static/images/products/' + product.code + '.jpg'" :alt="product.name"/>
						<p>{{ product.name }}</p>
						<p v-if="!disabled">Php {{ formatMoney(product.price) }}</p>
						<span>{{ product.categoryName }}</span>
						<button v-if="!disabled" type="button" v-on:click.prevent.stop="addToCart(product, $event)">Add to Cart</button>
					</div>
				</router-link>

				<h1 v-if="!products.length" class="text-center" style="margin: 4em 0;">No Results Found</h1>
				
			</div>
			
		</div>

		<transition name="fade">
			<notification v-if="notification" :nbm="nbm" :nbc="nbc"></notification>
		</transition>
	</div>
</template>

<script>
	import CartNotification from './CartNotification.vue';
	export default{
		props: ['alreadyAdded'],
		data(){
			return{

				notification: false,
				nbc: '#4DCC2F',
				nbm: '',

				products: [],
				filters: {},
				showadvs: false,

				showr: false,

				disabled: true
			}
		},
		methods: {

			formatMoney: formatMoney,

			advs: function(event){
				this.showadvs = !this.showadvs;
			},
			advFilters: function(filter, event){
				var obj = {};
				obj[filter] = event.target.value;
				this.$router.push({path: this.$route.fullPath, query: obj});
			},
			filterId: function(filtervalue){
				return filtervalue.split("|")[1].trim();
			},
			filterName: function(filtervalue){
				return filtervalue.split("|")[0].trim();
			},


			maxprice: function(event){
				var value = event.target.value;
				this.$router.push({path: this.$route.fullPath, query: {maxprice: value}});	
			},
			
			category: function(value, event){

				if(!$(event.target).hasClass("active-category")){
					$('.category').removeClass("active-category");
					$(event.target).addClass("active-category");	
				}else{
					// console.log('class exists fam!');
				}

				this.$router.push({path: this.$route.fullPath, query: {category: value}});		
			},


			addToCart: function(product, event){
				
				var self = this;
				this.$emit('addtocart', product);
				this.notification = true;
				setTimeout(function(){
					self.notification = false;
				}, 3000);

			},


			//DOM responsive functions go here
			ProductsResponsive: function(self){
    			var ww = $(window).outerWidth();
				if(ww < 992){
					self.showr = true;
					$('#products').css("margin-left", "0px");
				}else{
					self.showr = false;
					setTimeout(function(){
						$('#product-filters').css({
							"top": $('#nav').outerHeight() + "px",
							"height": "calc(100% - " + $('#nav').outerHeight() + "px)"
						});
						$('#products').css({
							"margin-left": $('#product-filters').outerWidth() + "px",
						});
					}, 100);
				}
    		}
		},
		created(){
			var self = this;

			//GET FILTERS
			$.ajax({
				url: 'static/php/allfilters.php',
				success: function(data){
					data = JSON.parse(data);
					self.filters = data;
				}
			});

			//GET products
			$.ajax({
				url: 'static/php/products.php',
				success: function(data){
					self.products = JSON.parse(data);
				}
			});

			//GET message
			if(this.alreadyAdded === false){
				this.nbm = 'Added to Cart';
			}else if(this.alreadyAdded === true){
				this.nbm = 'Item already in cart';
			}
			
		},
		mounted(){
			var self = this;
			relativeTo('nav', this.$el);
			
    		this.ProductsResponsive(self);
    		$(window).on("resize.Products", function(){
    			self.ProductsResponsive(self);
    		});

		},
		destroyed(){
			$(window).off("resize.Products");
		},
		watch: {
			'$route' (to, from){
				var self = this;
				var query = this.$route.query;
				// console.log(query);

				$.ajax({
					url: 'static/php/products.php',
					data: query,
					success: function(data){
						self.products = JSON.parse(data);
					}
				});

			},

			alreadyAdded: function(newval){
				if(newval === false){
					this.nbm = 'Added to Cart';
				}else if(newval === true){
					this.nbm = 'Item already in cart';
				}
			}
		},
		components: {
			'notification': CartNotification
		}
	}
</script>


// WEBPACK FOOTER //
// Products.vue?6942dd7a